import { render } from "./EditOrderPage.vue?vue&type=template&id=15925b49&scoped=true&ts=true"
import script from "./EditOrderPage.vue?vue&type=script&lang=ts"
export * from "./EditOrderPage.vue?vue&type=script&lang=ts"

import "./EditOrderPage.vue?vue&type=style&index=0&id=15925b49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15925b49"]])

export default __exports__